import { render, staticRenderFns } from "./AtividadesDollarInflux.vue?vue&type=template&id=b50e1b9c&scoped=true"
import script from "./AtividadesDollarInflux.vue?vue&type=script&lang=js"
export * from "./AtividadesDollarInflux.vue?vue&type=script&lang=js"
import style0 from "./AtividadesDollarInflux.vue?vue&type=style&index=0&id=b50e1b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50e1b9c",
  null
  
)

export default component.exports